import React from "react";
import serviceImg from "../../common/images/android-service.png";
import our from "../../common/images/Our.png";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className="max-w-[1280px] mx-auto md:py-10  px-5 md:px-10 py-5">
      <div className=" flex flex-col lg:flex-row  small:gap-10 gap-5">
        {/* Left Content */}
        <div className="lg:w-1/2 md:text-center text-start lg:text-left">
          <img src={our} alt="Our Img" className="h-20 w-15" />

          <div className="flex items-center gap-5 ">
            <p className="text-black uppercase tracking-widest font-semibold">
              Services
            </p>

            <p className="h-[3px] w-[30%] bg-webOranage"></p>
          </div>
          <h1 className="text-2xl xs:text-3xl small:text-4xl lg:text-5xl font-bold text-secondary mt-2">
            Hire Expert <span className="text-primary">Android</span>
            <br /> App Developers
          </h1>
          <p className="text-black small:text-md text-sm mt-4 font-semibold">
            Looking to create a powerful Android app? At Binary Ops, we
            specialize in developing custom Android applications tailored to
            your business needs. Our experienced developers build scalable,
            secure, and high-performance apps that deliver an exceptional user
            experience. Whether you're launching a new app or improving an
            existing one, we bring expertise and innovation to every project.
          </p>
          <Link to="/contact-us">
            <button className="small:mt-6 mt-3 px-10 py-2 bg-secondary text-white rounded-lg font-semibold small:text-lg text-sm hover:bg-blue-500 transition-all">
              LET’S TALK
            </button>
          </Link>
        </div>
        <div className="lg:w-1/2 bg-gray-50 flex justify-center relative">
          <img
            src={serviceImg}
            alt="Android Development"
            className="w-full max-w-sm md:max-w-md lg:max-w-lg drop-shadow-lg"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
